import React from "react";
import { useAuth } from "../contexts/AuthContext";
import OIDCLogin from "./OIDCLogin";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  // Show loading while checking authentication
  if (isLoading) {
    return (
      <div className="login-container">
        <div className="login-loading">
          <div className="loading-spinner"></div>
          <p>A verificar autenticação...</p>
        </div>
      </div>
    );
  }

  // If not authenticated, show login page
  if (!isAuthenticated) {
    return <OIDCLogin />;
  }

  // If authenticated, render the protected component
  return children;
};

export default ProtectedRoute;
